import { createContext, PropsWithChildren } from 'react';
import LoadingLottie from '../../../../public/images/lotties/loading.json';
import AmexLottie from '../../../../public/images/lotties/successful-amex.json';
import DiscoverLottie from '../../../../public/images/lotties/successful-discover.json';
import VisaLottie from '../../../../public/images/lotties/successful-visa.json';
import DefaultLottie from '../../../../public/images/lotties/successful.json';

export const LottiesContext = createContext<{
  visa: { ['default']: object } | object;
  amex: { ['default']: object } | object;
  discover: { ['default']: object } | object;
  default: { ['default']: object } | object;
  loading: { ['default']: object } | object;
}>({
  visa: VisaLottie,
  amex: AmexLottie,
  discover: DiscoverLottie,
  default: DefaultLottie,
  loading: LoadingLottie,
});

export default function LottiesProvider({ children }: PropsWithChildren) {
  return (
    <LottiesContext.Provider
      value={{
        visa: VisaLottie,
        amex: AmexLottie,
        discover: DiscoverLottie,
        default: DefaultLottie,
        loading: LoadingLottie,
      }}
    >
      {children}
    </LottiesContext.Provider>
  );
}
